export const SELECT_NO_OF_QUESTIONS = Array(5)
  .fill()
  .map((_, index) => ({ label: index + 1, value: index + 1 }));

export const SELECT_NO_OF_TRIVVYS = len => {
  const maxTrivvies = len;

  const minTrivvies = 0;

  const array = Array(len)
    .fill()
    .map((_, index) => ({ label: index + 1, value: index + 1 }))
    .slice(minTrivvies, maxTrivvies);

  return array;
};

export const createQuestionsChunks = (array, noOfChunks) => {
  const objects = array; // Your array of 32 objects
  const numObjects = objects.length;
  const numBuckets = noOfChunks;
  const minObjectsPerBucket = 1;
  const maxObjectsPerBucket = 5;

  const buckets = Array.from({ length: numBuckets }, () => []);

  let currentBucket = 0;
  for (let i = 0; i < numObjects; i++) {
    if (buckets[currentBucket].length >= maxObjectsPerBucket) {
      currentBucket++;
    }
    buckets[currentBucket].push(objects[i]);
  }

  // Distribute remaining objects to buckets with less than minObjectsPerBucket
  for (let i = 0; i < numBuckets && currentBucket < numBuckets; i++) {
    if (buckets[i].length < minObjectsPerBucket && currentBucket < numBuckets) {
      buckets[i].push(objects[currentBucket]);
      currentBucket++;
    }
  }

  console.log(buckets);
};
